import { ParentHoverContext } from "../../../contexts";
import { useHover } from "../../../hooks";
import { IconButton } from "../../IconButton";

import { containerStyle, iconButtonStyle } from "./NavigationHitArea.css";

export const NavigationHitArea = ({
  variant,
  onClick,
  disabled,
}: {
  variant: "left" | "right";
  onClick: () => void;
  disabled?: boolean;
}) => {
  const { hasHover, handleEnter, handleLeave } = useHover();

  return (
    <ParentHoverContext.Provider value={{ parentHover: hasHover }}>
      <button
        type="button"
        onClick={onClick}
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        className={containerStyle({ variant })}
      >
        <IconButton
          as="div"
          variant="opaqueCurrentColor"
          icon={variant === "left" ? "chevronLeft" : "chevronRight"}
          size="l"
          disabled={disabled}
          rounded
          className={iconButtonStyle}
        />
      </button>
    </ParentHoverContext.Provider>
  );
};
